<dialog-gala (clickClose)="hideModal()">
  <span gala-dialog-titre>{{lgTrad.TITRE}}</span>
  <div class="row">


    <div class="col">
      @if (lastSuiviExport != null) {
        <div class="row">
          Dernier traitement :
        </div>
        <div class="row">
          <div class="col-md-12">
            <input-gala type="text" [value]="lastSuiviExport.typeDocument" [label]="'Document'"
              [disabled]="true" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <input-gala type="text"
                [value]="lastSuiviExport.nomUtilisateur +' - '+ lastSuiviExport.dateDebut"
                [label]="'Dernière demande'" [disabled]="true" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input-gala type="text" [value]="lastSuiviExport.email" [label]="'Expédié à'" [disabled]="true" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <input-gala type="text" [value]="lastSuiviExport.periodeDebut+' - '+lastSuiviExport.periodeFin"
                  [label]="'Période'" [disabled]="true" />
                </div>
              </div>
              <div class="row">
                Traitement en cours :
              </div>
            }
            <div class="row">
              <div class="col-md-12">
                <!-- Parfaitement immonde mais n'a pas vocation à rester. Lorsqu'on aura + d'1 document, remettre le select et dégager l'input -->
                <!-- <select-gala [label]="'Document'" bindValue="value" [(ngModel)]="selectDocument"
                [options]="listeDocuments" (selected)="setUpForChosenDocument($event)">
              </select-gala> -->
              @if (selectDocument != undefined) {
                <input-gala type="text" [value]="selectDocument.nom"
                  [label]="'Document'" [disabled]="true" />
              }
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <select-gala [label]="'Format'" bindValue="value" [(ngModel)]="selectTypeFichier"
                [clearable]="false" [options]="listeTypesFichiers" placeholder="Type" />
              </div>
            </div>
            <form [formGroup]=" formData" autocomplete="off">
              <div class="row">
                <div class="col-md-12">
                  <input-gala type="text" formControlName="NUCHEPS" [label]="lgTrad.NUCHEPS"
                    [placeholder]="lgTrad.NUMERO_CHEPTELS" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <input-gala type="text" formControlName="MAIL" [label]="lgTrad.MAIL"
                      [placeholder]="lgTrad.MAIL" />
                    </div>
                  </div>


                  <div class="row">
                    <div class="col-md-12">
                      <date-gala [label]="lgTrad.DEBUT" [placeholder]="lgTrad.DEBUTPERIODE" formControlName="DDEBUT"
                        [disabled]="!droitsAccess.write" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <date-gala [label]="lgTrad.FIN" [placeholder]="lgTrad.FINPERIODE" formControlName="DFIN"
                          [disabled]="!droitsAccess.write" />
                        </div>
                      </div>
                    </form>
                    @if (blocsFormData != undefined) {
                      <form [formGroup]="blocsFormData" autocomplete="off">
                        <table class="table table-striped table-smaller table-not-rounded">
                          <caption>{{lgTrad.BLOCSAAFFICHER}}</caption>
                          <thead class="bg-primary">
                            <tr>
                              <th colspan=2 class="text-right clickable" (click)="inverserSelectionBlocs()">
                              {{selectionDeselectionTitle}}</th>
                            </tr>
                          </thead>
                          @for (bloc of listBlocs; track bloc) {
                            <tr>
                              <td>
                                {{bloc.texte}}
                              </td>
                              <td>
                                <div class=" pt-2 pb-2 ng-star-inserted">
                                  <mat-checkbox [formControlName]="bloc.valeur" />
                                </div>
                              </td>
                            </tr>
                          }
                        </table>
                      </form>
                    }
                  </div>
                  @if (nuchepErrors != undefined && nuchepErrors.length > 0) {
                    <div class="col" id="errorPanel">
                      <table class="table table-striped">
                        <thead>
                          <th>
                            Cheptel
                          </th>
                          <th>
                            Erreur
                          </th>
                          <th>
                            <i class="fa fa-lg fa-search btn-primary icon-agregat whiteSearch" title="Copier erreurs"
                            (click)="copyCsvErrorsToClipBoard()"></i>
                          </th>
                        </thead>
                        @for (nuchepError of nuchepErrors; track nuchepError; let odd = $odd) {
                          <tr [class]="(!odd)? 'odd' : 'even'">
                            <td>
                              {{nuchepError.nuchep}}
                            </td>
                            <td colspan="2">
                              {{nuchepError.error}}
                            </td>
                          </tr>
                        }
                      </table>
                    </div>
                  }
                </div>
                <div gala-dialog-actions>
                  <button mat-stroked-button color="primary" (click)="checkCheptels()">{{lgTrad.CALCULER}}</button>
                  @if (nuchepErrors != undefined && nuchepErrors.length > 0) {
                    <button mat-stroked-button color="primary" (click)="proceedToMassExport()"
                    >Calculer sans vérification</button>
                  }
                  <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.CANCEL}}</button>
                </div>
              </dialog-gala>